<template>
    <div class="sub-category" v-if="subcategory"  :class="lastTreeRelatedPosts ? 'sub-category-normal' : 'sub-category-empty'">
        <div class="title container-size-fixer main-container"  v-if="!parent">
            <ul>
                <li>
                    <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                </li>
                <li class="inheritance-container">
                    <span v-if="inheritance!==''" style="color: black;">
                    {{inheritance}}
                    =>
                    </span>
                   {{subcategory.name}}
                </li>
               <li class="show-more-btn-container">
                   <a @click.prevent="$router.push('/category-view/'+subcategory.slug)" >مشاهده بیشتر</a>
               </li>
            </ul>
        </div>
        <div class="news-box" style="position: relative;">
            <div class="row container-size-fixer main-container" style="margin:30px auto 40px auto!important;" v-if="lastTreeRelatedPosts">
                <NewsView v-for="postInfo in lastTreeRelatedPosts" :postInfo ="postInfo" :key="postInfo"/>
            </div>
            <div class="row" style="padding: 0!important;" v-else></div>
        </div>
        <div id="category-content" v-if="subcategory.active_childes && !parent">
            <div v-for="child in subcategory.active_childes" :key="child">
                <div class="category-content">
                    <SubCategory v-if="inheritance!==''" :subcategory = "child" :inheritance="inheritance + ' => ' + subcategory.name"/>
                    <SubCategory v-else :subcategory = "child" :inheritance="subcategory.name"/>
                </div>
            </div>
        </div>
        <div v-if="parent" @click.prevent="$router.push('/related-articles/'+subcategory.slug)" class="all-related-posts-btn">
            <span>
                (مشاهده تمام مقالات مرتبط)
            </span>
        </div>
    </div>
    <div class="sub-category" v-if="loadingMood">
        <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>
</template>

<script>
    import NewsView from '../components/NewsView'
    import axios from 'axios'
    export default {
        name: "SubCategory",
        components:{
            NewsView,
        },
        data(){
            return{
                loadingMood: false,
                lastTreeRelatedPosts:null
            }
        },
        props:['subcategory','inheritance','parent'],
        methods: {
            async getLastRelatedPosts(){
                try {
                    if(this.subcategory!==undefined){
                        this.loadingMood=true;
                        let response = await axios.get('api/getLastCategoryRelatedPosts/'+this.subcategory.slug+'/'+3);
                        this.loadingMood=false;
                        this.lastTreeRelatedPosts = response.data.results;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
        },
        created(){
                this.getLastRelatedPosts();
        }
    }
</script>

<style lang="scss"  scoped>
    .all-related-posts-btn{
        //color: rgb(204, 23, 29);
        width: 100%;
        cursor: pointer;
        &:hover{text-decoration: underline;}
    }
    .show-more-btn-container{
        margin-right: auto;
        a{
            white-space: pre;
        }
    }
    .inheritance-container{
        div{
            display: inline-block;
        }
    }
    .news-box{
        width: 100%;
        height: auto;
        /*opacity: 0.05;*/
        background-size: cover;
        background-repeat: no-repeat;
    }
    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 17px!important;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        ul{
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            position: relative;
            margin: auto;
            padding: 0;
            li{
                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
            a{
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: justify;
                color: #1a1a1a;
            }
        }


    }
    .main-container{
        margin: auto!important;
    }
    .sub-category{
        height: auto;
        padding: 50px 0;
    }
    .title{
        text-align: right;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-top: 0;
    }
    .sub-category-normal{
        min-height: 361px;
    }
    .sub-category-empty{
        background-color: rgba(232, 232, 232, 0.5);
        min-height:auto;
        ul{
            margin: 0;
            padding: 0;
        }
        .news-box{
            margin: 0;
        }
    }
</style>